import { render, staticRenderFns } from "./ContactListItem.vue?vue&type=template&id=11376890&scoped=true&"
import script from "./ContactListItem.vue?vue&type=script&lang=js&"
export * from "./ContactListItem.vue?vue&type=script&lang=js&"
import style0 from "./ContactListItem.vue?vue&type=style&index=0&id=11376890&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11376890",
  null
  
)

export default component.exports